// extracted by mini-css-extract-plugin
export var inner = "recruiter-module--inner--8c401";